import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemIsOpenSelector =
  (bomItemId: string, preferTreeView?: boolean) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemId, preferTreeView)

    return bomItem.type === 'Row' ? false : bomItem.isOpen
  }
